import VuexPersistence from 'vuex-persist'
import Cookies from 'js-cookie'

const COOKIE_KEY = 'praivech_super_admin'

export const vuexUser = new VuexPersistence({
  key: COOKIE_KEY,

  restoreState: (key) => {
    let cookieData = Cookies.get(key) || ''
    // console.log('🔍 Raw cookie data:', cookieData) // Debug ค่าจาก Cookies

    if (cookieData && typeof cookieData === 'string') {
      try {
        cookieData = JSON.parse(cookieData) // แปลง JSON
        // console.log('✅ Parsed cookie data:', cookieData)
      } catch (error) {
        console.error('❌ Error parsing JSON:', error)
        // console.log('🛑 Clearing corrupted cookie data...')
        Cookies.remove(key) // ล้างค่าที่เสียหาย
        return {} // คืนค่าเป็น Object เปล่าเพื่อป้องกันแอปพัง
      }
    }

    return {
      User: {
        ...cookieData
      }
    }
  },

  saveState: (key, state) => {
    const stateUser = state?.User || {}

    const cookieData = {
      id: stateUser.id || null,
      username: stateUser.username || null,
      firstName: stateUser.firstName || null,
      lastName: stateUser.lastName || null,
      email: stateUser.email || null,
      role: stateUser.role || null,
      imageUrl: stateUser?.imageUrl || null,
      tokenExpire: stateUser?.tokenExpire || null,
      accessToken: stateUser?.accessToken || null
    }

    // console.log('📝 Data before saving:', cookieData) // Debug ข้อมูลก่อนบันทึก

    try {
      const jsonData = JSON.stringify(cookieData)
      // console.log('🗂️ JSON Data:', jsonData) // Debug JSON ที่บันทึก

      const expires = cookieData.tokenExpire ? new Date(cookieData.tokenExpire) : 6
      Cookies.set(key, jsonData, { expires })
    } catch (error) {
      console.error('❌ Error stringifying JSON:', error)
    }
  },

  modules: ['User']
})

export default {
  vuexUser
}
